import { armorAPI } from '~/services/api';
import { type JSONBusinessRule, type ReorderRulePayload } from '~/types/BusinessRule';

const getBusinessRules = () =>
  armorAPI.request<JSONBusinessRule[]>({
    method: 'GET',
    url: `setting/rules/`,
  });

const deleteRule = (ruleId: string) =>
  armorAPI.request({
    method: 'DELETE',
    url: `setting/rules/${ruleId}/`,
  });

const updateRule = (payload: unknown) =>
  armorAPI.request<JSONBusinessRule>({
    data: payload,
    method: 'PUT',
    url: `setting/rules/`,
  });

const createRule = (payload: unknown) =>
  armorAPI.request({
    data: payload,
    method: 'POST',
    url: `setting/rules/`,
  });

const reorderRules = (payload: { rules: ReorderRulePayload[] }) =>
  armorAPI.request({
    data: payload,
    method: 'PUT',
    url: 'setting/rules/reorder/',
  });

const reprocessRules = () =>
  armorAPI.request({
    method: 'POST',
    url: 'setting/rules/reprocess/',
  });

const getRuleReprocessStatus = () =>
  armorAPI.request({
    method: 'GET',
    url: 'setting/rules/reprocess/',
  });

export {
  createRule,
  deleteRule,
  getBusinessRules,
  getRuleReprocessStatus,
  reorderRules,
  reprocessRules,
  updateRule,
};
